import Logout from './Logout';
export default Logout


// WEBPACK FOOTER //
// ./src/view/component/logout/index.js